import React from 'react';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Badge, IconButton, Tabs } from '@mui/material';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';

import { StyledContainer, StyledTitle, StyledTab } from '../../styles';
import { useEsgStakeholderAnalytics } from './StakeholdersAnalytics/hooks';
import { useEsgOrganization } from 'src/common/hooks';
import { useEsgReports } from 'src/Esg/hooks';
import { useEsgDmas } from 'src/Esg/Dmav2/hooks';

const getSelectedTab = () => {
  const url = window.location.href;
  const regex = /\/(selecting-stakeholders|analytics)\//;
  const match = url.match(regex);
  if (match) {
    return match[1];
  } else {
    return 'selecting-stakeholders';
  }
};

export default function SelectingStakeHolders() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { reportId } = useParams();
  const { _instance: report } = useEsgReports({ id: Number(reportId) });
  const { _instance: dma } = useEsgDmas({ id: report?.esg_dma_id });
  const { id: organizationId } = useEsgOrganization();

  const { dataCount } = useEsgStakeholderAnalytics(
    organizationId,
    reportId as string
  );

  const tab = getSelectedTab();

  if (!dma) return null;

  const handleTabChange = (_: any, _tab: string) => {
    const base = `/esg/reports/${reportId}/dma/v${dma.version}/stakeholders/${_tab}`;
    switch (_tab) {
      case 'analytics':
        return navigate(`${base}/dashboard`);
      default:
        return navigate(base);
    }
  };

  return (
    <StyledContainer>
      <StyledTitle>
        <IconButton onClick={() => navigate('../../dma/v1')}>
          <KeyboardArrowLeftIcon fontSize="large" sx={{ color: '#38414f' }} />
        </IconButton>
        {t('esg:dma.selectingStakeholders.title')}
      </StyledTitle>
      <Tabs sx={{ mt: '20px' }} value={tab} onChange={handleTabChange}>
        <StyledTab
          label={t('esg:dma.stakeholderTabs.selectingStakeholders')}
          id="selecting-stakeholders"
          value="selecting-stakeholders"
        />
        <StyledTab
          label={
            dataCount > 0 ? (
              <Badge
                badgeContent={dataCount}
                color="primary"
                sx={{ pr: '10px' }}
              >
                {t('esg:dma.stakeholderTabs.analytics')}
              </Badge>
            ) : (
              t('esg:dma.stakeholderTabs.analytics')
            )
          }
          id="analytics"
          value="analytics"
        />
      </Tabs>
      <Outlet />
    </StyledContainer>
  );
}
